export default function SectionApp() {
  return (
    <section id="app" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-4xl mx-auto">
        <div className="bg-gradient-to-br from-primary-500 via-primary-600 to-accent-600 rounded-2xl p-8 md:p-12 flex flex-col lg:flex-row items-center gap-8">
          <div className="flex-1 text-center lg:text-left">
            <h2 className="font-heading text-2xl md:text-3xl text-background-50 mb-3">
              移动追剧
            </h2>
            <p className="text-base text-background-100/90 leading-relaxed mb-6">
              夜猫影院APP现已上线！支持iOS和Android双平台，躺在床上也能畅享高清追剧体验。
              夜间模式专为夜猫子设计，护眼不伤神，离线缓存让你随时随地继续追。
            </p>
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-3">
              <button className="px-6 py-2.5 bg-background-50 text-primary-600 font-medium text-sm rounded-lg hover:bg-background-100 transition-colors cursor-pointer whitespace-nowrap">
                <i className="ri-apple-fill mr-2"></i>App Store
              </button>
              <button className="px-6 py-2.5 bg-background-50/90 text-primary-600 font-medium text-sm rounded-lg hover:bg-background-100 transition-colors cursor-pointer whitespace-nowrap">
                <i className="ri-android-fill mr-2"></i>Google Play
              </button>
              <button className="px-6 py-2.5 bg-background-50/80 text-primary-600 font-medium text-sm rounded-lg hover:bg-background-100 transition-colors cursor-pointer whitespace-nowrap">
                <i className="ri-download-2-line mr-2"></i>直接下载APK
              </button>
            </div>
            <p className="text-xs text-background-200/80 mt-4">已累计下载 <strong className="text-background-50">800万+</strong> 次 · 评分 <strong className="text-background-50">4.8</strong></p>
          </div>
          <div className="w-40 md:w-48 shrink-0">
            <img
              src="https://readdy.ai/api/search-image?query=A%20modern%20smartphone%20floating%20displaying%20a%20streaming%20app%20interface%20with%20warm%20orange%20and%20dark%20theme%2C%20TV%20show%20thumbnails%20on%20the%20screen%2C%20minimal%20UI%20design%2C%20clean%20mockup%20presentation%2C%20soft%20lighting%2C%203D%20render%20style%2C%20sleek%20modern%20aesthetic&width=400&height=700&seq=app-mockup&orientation=portrait"
              alt="夜猫影院APP界面"
              className="w-full h-auto"
              width="400"
              height="700"
            />
          </div>
        </div>
      </div>
    </section>
  );
}